import { FC } from 'react';
import MobileDefaultMatchRender from './TypeMatch/MobileDefaultMatchRender';
import SingleFileMatchRender from './TypeMatch/SingleFileMatchRender';
import TripleThreatMatchRender from './TypeMatch/TripleThreatMatchRender';
import FatalFourMatchRender from './TypeMatch/FatalFourMatchRender';
import FiveFayMatchRender from './TypeMatch/FiveFayMatchRender';
import SixWayMatchRender from './TypeMatch/SixWayMatchRender';
import SevenWayMatchRender from './TypeMatch/SevenWayMatchRender';
import EightWayMatchRender from './TypeMatch/EightWayMatchRender';
import TagTeamMatchRender from './TypeMatch/TagTeamMatchRender';
import ThreeVsThreeMatchRender from './TypeMatch/ThreeVsThreeMatchRender';
import ThreeTagMatchRender from './TypeMatch/ThreeTagMatchRender';
import FourTagMatchRender from './TypeMatch/FourTagMatchRender';
import FiveTagMatchRender from './TypeMatch/FiveTagMatchRender';
import SixTagMatchRender from './TypeMatch/SixTagMatchRender';
import HandicapMatchRender from './TypeMatch/HandicapMatchRender';
import RumbleMatchRender from './TypeMatch/RumbleMatchRender';
import FourVsFourMatchRender from './TypeMatch/FourVsFourMatchRender';
import FiveVsFiveMatchRender from './TypeMatch/FiveVsFiveMatchRender';
import SixVsSixMatchRender from './TypeMatch/SixVsSixMatchRender';
import NwoSixMatchRender from './TypeMatch/NwoSixMatchRender';
import NwoEightMatchRender from './TypeMatch/NwoEightMatchRender';
import NwoTenMatchRender from './TypeMatch/NwoTenMatchRender';
import EliminationChamberMatchRender from './TypeMatch/EliminationChamberMatchRender';
import type { Match } from '../../../types';

interface RenderFightInsideBoxComponentProps {
    fight: Match;
    withWinner: boolean;
    isExpanded?: boolean;
}

const RenderFightInsideBoxComponent: FC<RenderFightInsideBoxComponentProps> = ({ fight, withWinner, isExpanded = false }) => {
    switch (fight.type_match?.type) {
        case 'single':
            return <SingleFileMatchRender
            matchInfo={fight}
            withWinner={withWinner}
            isExpanded={isExpanded}
        />;
        case 'triple':
            return <TripleThreatMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'fatal':
            return <FatalFourMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'five':
            return <FiveFayMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'six':
            return <SixWayMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'seven':
            return <SevenWayMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'eight':
            return <EightWayMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'tag':
            return <TagTeamMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'three_tag':
            return <ThreeTagMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'four_tag':
            return <FourTagMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'five_tag':
            return <FiveTagMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'six_tag':
            return <SixTagMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'handicap':
            return <HandicapMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        case 'special':
            switch (fight.type_match?.name.toLowerCase()) {
                case '3 vs 3':
                    return <ThreeVsThreeMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                case '4 vs 4':
                    return <FourVsFourMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                case '5 vs 5':
                    return <FiveVsFiveMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                case '6 vs 6':
                    return <SixVsSixMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                case 'NWO Match 6'.toLowerCase():
                    return <NwoSixMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                case 'NWO Match 8'.toLowerCase():
                    return <NwoEightMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                case 'NWO Match 10'.toLowerCase():
                    return <NwoTenMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                case 'Elimination Chamber'.toLowerCase():
                    return <EliminationChamberMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
                default:
                    return <MobileDefaultMatchRender
                        matchInfo={fight}
                        withWinner={withWinner}
                        isExpanded={isExpanded}
                    />;
            }
        case 'rumble':
            return <RumbleMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
        default:
            return <MobileDefaultMatchRender
                matchInfo={fight}
                withWinner={withWinner}
                isExpanded={isExpanded}
            />;
    }
}

export default RenderFightInsideBoxComponent;
